import { StepExperiment } from '#src/app/pages/startAPetitionV2/shared/components';

import { ChatAppEntry } from './components/ChatAppEntry';
import { Create } from './components/Create';
import { Edit } from './components/Edit';
import { Edit as EditAiTextLabeling } from './components/EditAiTextLabeling';
import { Intro } from './components/Intro';
import { IssuePrompt } from './components/IssuePrompt';
import { Location } from './components/Location';
import { Media } from './components/Media';
import { OptionalPreview } from './components/OptionalPreview';
import { PersonalPrompt } from './components/PersonalPrompt';
import { PersonalPrompt as PersonalPromptAiTextLabeling } from './components/PersonalPromptAiTextLabeling';
import { PrePublish } from './components/PrePublish';
import { Preview } from './components/Preview';
import { SocialEntry } from './components/SocialEntry';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const { actions } = usePageBody();

	// oxlint-disable-next-line complexity
	const Component = (() => {
		switch (true) {
			case actions.matches('intro'):
				return <Intro />;
			case actions.matches('issue'):
				return <IssuePrompt />;
			case actions.matches('personal-story'):
				return (
					<StepExperiment
						experiment="sapAiTextLabeling"
						control={PersonalPrompt}
						variants={{ enabled: PersonalPromptAiTextLabeling }}
					/>
				);
			case actions.matches('chat-app-entry'):
				return <ChatAppEntry />;
			case actions.matches('social'):
				return <SocialEntry />;
			case actions.matches('optional-preview'):
				return <OptionalPreview />;
			case actions.matches('preview'):
				return <Preview />;
			case actions.matches('create'):
				return <Create />;
			case actions.matches('edit'):
				return (
					<StepExperiment experiment="sapAiTextLabeling" control={Edit} variants={{ enabled: EditAiTextLabeling }} />
				);
			case actions.matches('location'):
				return <Location />;
			case actions.matches('media'):
				return <Media />;
			case actions.matches('prepublish'):
				return <PrePublish />;
			default:
				// probably throw an error here and handle in error boundary?
				return <div>unknown state</div>;
		}
	})();

	return Component;
}
